import { EmailTemplateDto } from './email-template-dto.model';


export class EmailSettingDto implements IEmailSettingDto {
    id!: number;
    emailTemplate!: EmailTemplateDto;
    leaderType!: number | undefined;
    specificUser!: boolean;
    isActive!: boolean;
    specificUserIds!: number[] | undefined;
    sendEmailOption!: number | undefined;

    constructor(data?: IEmailSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.emailTemplate = _data["emailTemplate"] ? EmailTemplateDto.fromJS(_data["emailTemplate"]) : <any>undefined;
            this.leaderType = _data["leaderType"];
            this.specificUser = _data["specificUser"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["specificUserIds"])) {
                this.specificUserIds = [] as any;
                for (let item of _data["specificUserIds"])
                    this.specificUserIds!.push(item);
            }
            this.sendEmailOption = _data["sendEmailOption"];
        }
    }

    static fromJS(data: any): EmailSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["emailTemplate"] = this.emailTemplate ? this.emailTemplate.toJSON() : <any>undefined;
        data["leaderType"] = this.leaderType;
        data["specificUser"] = this.specificUser;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.specificUserIds)) {
            data["specificUserIds"] = [];
            for (let item of this.specificUserIds)
                data["specificUserIds"].push(item);
        }
        data["sendEmailOption"] = this.sendEmailOption;
        return data; 
    }
}

export interface IEmailSettingDto {
    id: number;
    emailTemplate: EmailTemplateDto;
    leaderType: number | undefined;
    specificUser: boolean;
    isActive: boolean;
    specificUserIds: number[] | undefined;
    sendEmailOption: number | undefined;
}

